import { useEffect, useRef } from "react";
import { Form, Formik, FormikProps } from "formik";
import { yup } from "../../../validation/yup";
import { TextareaField } from "../../common/form-fields/TextareaField";
import { Note } from "../../../types/note/Note";
import { RequestState } from "../../../constants/request-state";
import { isRequesting, isRequestSuccess } from "../../../utils/request-state.utils";
import { useAutoFocus } from "../../../effects/useAutoFocus";

const replyValidationSchema = yup.object().shape({
    text: yup.string().trim().required().max(255),
});

interface Props {
    text?: string;
    note: Note;
    requestState?: RequestState
    onSave: (text: string) => void;
    onCancel: () => void;
}

interface ReplyEditContent {
    text: string
}

export function EditNoteReply({ text = "", note, requestState, onSave, onCancel }: Props) {
    const formikRef = useRef<FormikProps<ReplyEditContent>>(null);
    const textareaRef = useAutoFocus<HTMLTextAreaElement>();

    useEffect(() => {
        if (isRequestSuccess(requestState) && formikRef.current) {
            formikRef.current.resetForm();
        }
    }, [requestState])


    const handleSubmit = ({ text }: ReplyEditContent) => onSave(text);

    return (
        <Formik
            initialValues={{ text }}
            validationSchema={replyValidationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, isValid, dirty }) =>
                <Form noValidate={true} className="notes-reply-state">
                    <TextareaField
                        textareaRef={textareaRef}
                        autoFocus={true}
                        label={`Reply to ${note.user.firstName} ${note.user.lastName}`}
                        name="text"
                        placeholder="Add Reply"
                        wrapperClassName="notes-reply-message"
                        capitalize={false}
                        disabled={isRequesting(requestState)}
                        maxLength={255}
                    />
                    <div className="notes-footer">
                        <div className="notes-action-buttons">
                            <button
                                type="button"
                                className="btn btn-sm btn-ghost"
                                disabled={isRequesting(requestState)}
                                onClick={onCancel}
                            >
                                cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-sm btn-main"
                                disabled={!isValid || !values.text || isRequesting(requestState) || !dirty}
                            >
                                save
                            </button>
                        </div>
                    </div> 
                </Form>}
        </Formik>
    )
}